// extracted by mini-css-extract-plugin
module.exports = {"hoverZoom":"hover-zoom_hoverZoom__oDsI8","hoverBorderShadow":"hover-zoom_hoverBorderShadow__9BBg_"};